import * as React from 'react';
import Icon from '@telia-front/icon';
export default class TimelineItem extends React.Component {
    constructor() {
        super(...arguments);
        this.getIcon = () => {
            const { state } = this.props;
            switch (state) {
                case 'warning':
                    return '#alert';
                default:
                    return '#check-round';
            }
        };
    }
    BEM() {
        const classArray = ['timeline__entry'];
        if (this.props.state === 'warning') {
            classArray.push('has-warning');
        }
        if (this.props.state === 'current') {
            classArray.push('is-current');
        }
        if (this.props.state === 'done') {
            classArray.push('is-done');
        }
        return classArray.join(' ');
    }
    render() {
        const { children } = this.props;
        return (React.createElement("article", { className: this.BEM() },
            React.createElement(Icon, { modifiers: this.getIcon(), className: "timeline__icon", size: "xxs" }),
            React.createElement("div", { className: "timeline__content" }, children)));
    }
}
